<template>
  <router-link
    class="main-logo-wrapper"
    :style="`min-width: ${width}px; max-width: ${width}px;`"
    :to="link"
    :target="target"
  >
    <img
      v-if="white"
      class="main-logo"
      :style="`max-width: ${width}px;`"
      :src="whiteLogoSrc"
      alt="Undead Phoenix"
    />
    <img
      v-else-if="black"
      class="main-logo"
      :style="`max-width: ${width}px;`"
      :src="blackLogoSrc"
      alt="Undead Phoenix"
    />
    <img
      v-else
      class="main-logo"
      :style="`max-width: ${width}px;`"
      :src="defaultLogoSrc"
      alt="Undead Phoenix"
    />
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Logo",
  props: {
    width: {
      type: Number,
      default: 90,
    },
    white: {
      type: Boolean,
      default: false,
    },
    black: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: "/",
    },
    target: {
      type: String,
      default: "_self",
    },
  },
  methods: {
    newLogoRoute() {
      window.open(process.env.VUE_APP_URL, "_blank");
    },
  },
  computed: {
    ...mapGetters(["window"]),
    isMobile() {
      return this.window.windowWidth <= 768;
    },
    assetDeviceFolder() {
      return this.isMobile ? "mobile" : "desktop";
    },
    whiteLogoSrc() {
      return require(`@/assets/img/${this.assetDeviceFolder}/media/logo-white.png`);
    },
    blackLogoSrc() {
      return require(`@/assets/img/${this.assetDeviceFolder}/media/logo-black.png`);
    },
    defaultLogoSrc() {
      return require(`@/assets/img/${this.assetDeviceFolder}/media/logo.png`);
    },
  },
};
</script>

<style scoped>
.main-logo-wrapper {
  position: relative;
  cursor: pointer !important;
  transition: all 200ms ease;
}
.main-logo-wrapper:active {
  transform: scale(0.95);
}
.main-logo {
  width: 100%;
  height: auto;
}
</style>
